module.exports = __webpack_public_path__ + "img/ashmanslogo.ccf25102.png";